import * as r from "react";
import { u as e } from "./index-eoE_jzLb.js";
var s = r.useId || (() => {
}), n = 0;
function d(t) {
  const [o, u] = r.useState(s());
  return e(() => {
    u((a) => a ?? String(n++));
  }, [t]), t || (o ? `radix-${o}` : "");
}
export {
  d as u
};
